import { Reducer } from "redux";

import {
    STROLLER_PRODUCT_PHOTO_FETCH_FAILURE,
    STROLLER_PRODUCT_PHOTO_FETCH_REQUEST,
    STROLLER_PRODUCT_PHOTO_FETCH_SUCCESS,
    STROLLER_PRODUCT_PHOTO_UPDATE_THUMBS,
    StrollerProductPhotoFetchFailureAction,
    StrollerProductPhotoFetchRequestAction,
    StrollerProductPhotoFetchSuccessAction,
    StrollerProductPhotoUpdateThumbsAction,
} from "@/mk2/apps/strollers/containers/StrollerProductPhoto/StrollerProductPhoto.actions";
import { tupdate } from "@/mk2/helpers/types";
import { LoadingState, loadingState } from "@/mk2/reducers/loadingState";

export interface StrollerProductPhotoState {
    loadingState: LoadingState;
    strollerId: number | null;
    strollerPhotosIds: number[];
    strollerVariantIds: number[];
}

export const initialStrollerProductPhotoState = {
    loadingState: LoadingState.INIT,
    strollerId: null,
    strollerPhotosIds: [],
    strollerVariantIds: [],
};

export interface StrollersProductPhotosState {
    pages: {
        [strollerSlug: string]: StrollerProductPhotoState;
    };
    hideThumbnails: boolean;
    thumbsKey: string;
}

export const initialStrollersProductPhotosState: StrollersProductPhotosState = {
    pages: {},
    hideThumbnails: null,
    thumbsKey: new Date().toISOString(),
};

declare type StrollersProductPhotosReducerAction =
    | StrollerProductPhotoFetchRequestAction
    | StrollerProductPhotoFetchSuccessAction
    | StrollerProductPhotoFetchFailureAction
    | StrollerProductPhotoUpdateThumbsAction;

export const strollersProductPhotoReducer: Reducer<
    StrollersProductPhotosState,
    StrollersProductPhotosReducerAction
> = (state = initialStrollersProductPhotosState, action) => {
    switch (action.type) {
        case STROLLER_PRODUCT_PHOTO_FETCH_REQUEST:
        case STROLLER_PRODUCT_PHOTO_FETCH_FAILURE: {
            const strollerSlug = action.strollerSlug;
            return tupdate(state, {
                pages: tupdate(state.pages, {
                    [strollerSlug]: tupdate(
                        state.pages[strollerSlug] || initialStrollerProductPhotoState,
                        {
                            loadingState: loadingState(undefined, action),
                        },
                    ),
                }),
            });
        }

        case STROLLER_PRODUCT_PHOTO_FETCH_SUCCESS: {
            const strollerSlug = action.strollerSlug;
            return tupdate(state, {
                pages: tupdate(state.pages, {
                    [strollerSlug]: tupdate(
                        state.pages[strollerSlug] || initialStrollerProductPhotoState,
                        {
                            loadingState: loadingState(undefined, action),
                            strollerId: action.response.result.stroller,
                            strollerPhotosIds: action.response.result.strollerPhotos,
                            strollerVariantIds: action.response.result.strollerVariants,
                        },
                    ),
                }),
            });
        }

        case STROLLER_PRODUCT_PHOTO_UPDATE_THUMBS: {
            return tupdate(state, {
                hideThumbnails: action.hide,
                thumbsKey: new Date().toISOString(),
            });
        }

        default:
            return state;
    }
};
